<template>
  <div class="calico-tooltip">
    <i
      class="bi bi-question-circle"
      @click.prevent="show = true"
    />
    <Modal
      v-if="show"
      @close="show = false"
    >
      <template #content>
        <div class="content">
          <h1 class="heading--xsmall">
            {{ header }}
          </h1>
          <span class="body--medium">{{ body }}</span>
        </div>
      </template>
      <template #footer>
        <button
          class="button-utility"
          @click="show = false"
        >
          Close
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/template/modal/index.vue"

export default {
    name: 'CalicoTooltip',
    components: {
        Modal
    },
    props: {
        header: {
            type: String,
            default: ""
        },
        body: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            show: false
        }
    }
}
</script>

<style scoped lang="scss">
.calico-tooltip {
    i {
        font-size: $icon-small;
        color: $color-lapis;
    }
    .content {
        @include stack-space($space-small);
        @include inset-space($space-large);
        width: 100%;
    }
}
</style>